import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"menu\"><path fill=\"currentColor\" d=\"M2050,1089 L2050,1140.25 L2450,1140.25 L2450,1089 L2050,1089 Z M2050,1227.375 L2050,1278.625 L2450,1278.625 L2450,1227.375 L2050,1227.375 Z M2050,1365.75 L2050,1417 L2450,1417 L2450,1365.75 L2050,1365.75 Z\" transform=\"translate(-2000 -1000)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol